import camelCase from 'lodash/camelCase'
const templates = {}
const excludedTemplates = ['commonTemplate', 'detailTemplate', 'headerTemplate']
const requireComponents = require.context('../templates/', false, /[\w]+Template\.vue$/)
requireComponents.keys().forEach(fileName => {
  const templateName = camelCase(fileName.replace(/^\.\/(.+Template)\.vue/, '$1'))
  if (!excludedTemplates.includes(templateName)) {
    const componentConfig = requireComponents(fileName)
    templates[templateName] = componentConfig.default || componentConfig
  }
})
export default templates
